package com.fireavert.topnav.client.presentation

import com.fireavert.auth.user_authentication.client.UserAuthenticator

class TopNavController(private val topNav: TopNav, private val userAuthenticator: UserAuthenticator) {
    fun onLoad() = topNav.onLoad()
    fun clickedLogout() = userAuthenticator.logout()
    fun clickedProfile() = topNav.clickedProfile()
}